import React, { useEffect, useRef, useState } from "react";
import styles from "./styles.module.css";
import cx from "classnames";
import { Msg } from "src/i18n/Msg";
import { DictionaryKey } from "src/types/language";
import { PAGES } from "src/types/navigation";

export type TabItem = {
  value: string;
  label: DictionaryKey;
};

type Props = {
  items: TabItem[];
  onItemSelect?: (value: string) => void;
  activeTab: string;
  underlinedValue?: PAGES;
};

export const Tab: React.FC<Props> = ({
  items,
  onItemSelect,
  activeTab,
  underlinedValue,
}) => {
  const [activeItem, setActiveItem] = useState<string>(activeTab);
  const containerRef = useRef<HTMLDivElement>(null);
  const tabRefs = useRef<Record<string, HTMLButtonElement | null>>({});
  useEffect(() => {
    const activeRef = tabRefs.current[activeItem];
    const container = containerRef.current;
    if (activeRef && container) {
      const left = activeRef.offsetLeft - container.offsetWidth / 2 + activeRef.offsetWidth / 2;
      container.scrollTo({ left, behavior: "smooth" });
    }
  }, [activeItem]);

  const handleClick = (value: string) => {
    setActiveItem(value);
    if (onItemSelect) {
      onItemSelect(value);
    }
  };

  return (
    <div className={styles.menuContainer} ref={containerRef}>
      {items.map((item) => (
        <button
          ref={(el) => {
            tabRefs.current[item.value] = el;
          }}
          key={item.value}
          className={cx(styles.menuItem, {
            [styles.menuItemActive]: activeItem === item.value,
            [styles.gradienetText]:
              item.value === underlinedValue && activeItem !== item.value,
          })}
          type="button"
          onClick={() => handleClick(item.value)}
        >
          <Msg id={item.label} />
        </button>
      ))}
    </div>
  );
};
